// src/api/auth.ts

import { apiClient } from './client';
import {
    User, RegisterRequest, LoginRequest, ApiResponse,
    ChangePasswordRequest, InvitationValidation
} from '../types';

export const authApi = {
    /**
     * Получить CSRF-токен (перед логином/регистрацией)
     * Spring положит XSRF-TOKEN в cookie, а сам ответ вернёт сам токен
     */
    getCsrfToken: async (): Promise<ApiResponse<any>> => {
        return apiClient.get('/auth/csrf');
    },

    /**
     * Логин — Spring Security ждёт form-data (не JSON)
     */
    login: async (credentials: LoginRequest): Promise<ApiResponse<{ status: string }>> => {
        return apiClient.postForm<ApiResponse<{ status: string }>>('/auth/login', {
            username: credentials.username,
            password: credentials.password,
        });
    },


    // Валидация токена-приглашения (публичный)
    validateInvitation: async (token: string): Promise<ApiResponse<InvitationValidation>> => {
        return apiClient.get<InvitationValidation>(`/auth/invitation/${token}`);
    },

    // Регистрация (обновлена — требует invitationToken в теле)
    /**
     * Регистрация — JSON
     */
    register: async (data: RegisterRequest): Promise<ApiResponse<User>> => {
        return apiClient.post<User>('/auth/register', data);
    },

    /**
     * Получить текущего пользователя
     */
    me: async (): Promise<ApiResponse<User>> => {
        return apiClient.get<User>('/auth/me');
    },

    /**
     * Выход
     */
    logout: async (): Promise<ApiResponse<void>> => {
        return apiClient.post<void>('/auth/logout');
    },

    /**
     * Смена пароля (обязательная или обычная)
     */
    changePassword: async (data: ChangePasswordRequest): Promise<ApiResponse<User>> => {
        return apiClient.post<User>('/auth/change-password', data);
    },
};